import { ActionType } from 'typesafe-actions';
import { ILanguageData } from './models';
import * as actions from './actions';

export interface ILanguageState {
	readonly data: ILanguageData[];
	readonly loading: boolean;
	readonly error?: string;
}

export type LanguagesAction = ActionType<typeof actions>;

const initialState: ILanguageState = {
	data: [{ id: '00', name: 'English' }],
	loading: false,
};

const reducer = (state: ILanguageState = initialState, action: LanguagesAction) => {
	switch (action.type) {
		case actions.FETCH_LANGUAGES_INIT:
			return { ...state, loading: true };
		case actions.FETCH_LANGUAGES_SUCCESS:
			return { ...state, loading: false, data: action.languages };
		case actions.FETCH_LANGUAGES_FAILURE:
			return { ...state, loading: false, error: action.error };
		default:
			return state;
	}
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/modules/languages/reducer.ts